// extracted by mini-css-extract-plugin
export default {"ViewerHeader":"ViewerHeader-module__ViewerHeader___3v98l","ViewerHeaderTypeNav":"ViewerHeader-module__ViewerHeaderTypeNav___3J3qP"};